(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements && window.customElements.get('email-popup')) return;

    function readCookie(name) {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()\[\]\\\/\+^]/g, '\\$&') + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    }
    function writeCookie(name, value, days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    }

    var DISMISS_COOKIE = 'mlz_popup_dismissed';
    var SUBSCRIBE_COOKIE = 'mlz_popup_subscribed';

    var EmailPopup = function () {
      return Reflect.construct(HTMLElement, [], EmailPopup);
    };
    EmailPopup.prototype = Object.create(HTMLElement.prototype);
    EmailPopup.prototype.constructor = EmailPopup;
    Object.setPrototypeOf(EmailPopup, HTMLElement);

    EmailPopup.prototype.connectedCallback = function () {
      if (this._initialised) return;
      this._initialised = true;

      this.designMode = !!(window.Shopify && window.Shopify.designMode);

      if (!this.designMode && (readCookie(SUBSCRIBE_COOKIE) || readCookie(DISMISS_COOKIE))) return;

      this.delay = parseInt(this.dataset.delay, 10) || 0;
      this.dismissDays = parseInt(this.dataset.dismissDays, 10) || 14;
      this.subscribeDays = parseInt(this.dataset.subscribeDays, 10) || 365;
      this.klaviyoKey = this.dataset.klaviyoKey;
      this.klaviyoList = this.dataset.klaviyoList;
      this.customSource = this.dataset.customSource || 'Mellenza popup';

      this.form = this.querySelector('[data-popup-form]');
      this.errorEl = this.querySelector('[data-popup-error]');
      this.submitBtn = this.querySelector('.email-popup__submit');
      this.submitLabel = this.querySelector('[data-submit-label]');
      this.originalLabel = this.submitLabel ? this.submitLabel.textContent : '';

      var self = this;
      this._onClose = function (e) {
        if (e.target.matches('[data-popup-close]')) self.close(true);
      };
      this._onKey = function (e) {
        if (e.key === 'Escape' && self.getAttribute('data-open') === 'true') self.close(true);
      };
      this._onSubmit = function (e) { e.preventDefault(); self.submit(); };

      this.addEventListener('click', this._onClose);
      document.addEventListener('keydown', this._onKey);
      if (this.form) this.form.addEventListener('submit', this._onSubmit);

      if (this.designMode) {
        this.open();
        this._onSectionSelect = function (e) {
          if (e.detail && e.detail.sectionId && self.id.indexOf(e.detail.sectionId) !== -1) self.open();
        };
        document.addEventListener('shopify:section:select', this._onSectionSelect);
      } else {
        this.timer = window.setTimeout(function () { self.open(); }, this.delay * 1000);
      }
    };

    EmailPopup.prototype.disconnectedCallback = function () {
      window.clearTimeout(this.timer);
      document.removeEventListener('keydown', this._onKey);
      if (this._onSectionSelect) document.removeEventListener('shopify:section:select', this._onSectionSelect);
    };

    EmailPopup.prototype.open = function () {
      this.setAttribute('data-open', 'true');
      this.setAttribute('aria-hidden', 'false');
      var input = this.querySelector('input[type="email"]');
      if (input) window.setTimeout(function () { input.focus(); }, 240);
    };

    EmailPopup.prototype.close = function (recordDismiss) {
      this.removeAttribute('data-open');
      this.setAttribute('aria-hidden', 'true');
      if (this.designMode) return;
      if (recordDismiss && this.getAttribute('data-view') !== 'success') {
        writeCookie(DISMISS_COOKIE, '1', this.dismissDays);
      }
    };

    EmailPopup.prototype.submit = function () {
      var self = this;
      var input = this.form.querySelector('input[type="email"]');
      var email = (input.value || '').trim();
      if (!email || email.indexOf('@') === -1) {
        this.showError();
        return;
      }
      if (this.errorEl) this.errorEl.hidden = true;
      if (this.submitBtn) {
        this.submitBtn.setAttribute('aria-busy', 'true');
        if (this.submitLabel) this.submitLabel.textContent = '…';
      }

      if (this.designMode || !this.klaviyoKey || !this.klaviyoList) {
        this.setAttribute('data-view', 'success');
        if (this.submitBtn) {
          this.submitBtn.setAttribute('aria-busy', 'false');
          if (this.submitLabel) this.submitLabel.textContent = this.originalLabel;
        }
        return;
      }

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: this.customSource,
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: this.klaviyoList } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.klaviyoKey), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (res.status === 202) {
          writeCookie(SUBSCRIBE_COOKIE, '1', self.subscribeDays);
          self.setAttribute('data-view', 'success');
        } else {
          self.showError();
        }
      }).catch(function () {
        self.showError();
      }).then(function () {
        if (self.submitBtn) {
          self.submitBtn.setAttribute('aria-busy', 'false');
          if (self.submitLabel) self.submitLabel.textContent = self.originalLabel;
        }
      });
    };

    EmailPopup.prototype.showError = function () {
      if (this.errorEl) this.errorEl.hidden = false;
    };

    window.customElements.define('email-popup', EmailPopup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements && window.customElements.get('quiz-popup')) return;

    function readCookie(name) {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()\[\]\\\/\+^]/g, '\\$&') + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    }
    function writeCookie(name, value, days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    }

    var DISMISS_COOKIE = 'mlz_popup_dismissed';
    var SUBSCRIBE_COOKIE = 'mlz_popup_subscribed';

    var QuizPopup = function () {
      return Reflect.construct(HTMLElement, [], QuizPopup);
    };
    QuizPopup.prototype = Object.create(HTMLElement.prototype);
    QuizPopup.prototype.constructor = QuizPopup;
    Object.setPrototypeOf(QuizPopup, HTMLElement);

    QuizPopup.prototype.connectedCallback = function () {
      if (this._initialised) return;
      this._initialised = true;

      this.designMode = !!(window.Shopify && window.Shopify.designMode);

      if (!this.designMode && (readCookie(SUBSCRIBE_COOKIE) || readCookie(DISMISS_COOKIE))) return;

      this.delay = parseInt(this.dataset.delay, 10) || 0;
      this.dismissDays = parseInt(this.dataset.dismissDays, 10) || 14;
      this.subscribeDays = parseInt(this.dataset.subscribeDays, 10) || 365;
      this.klaviyoKey = this.dataset.klaviyoKey;
      this.klaviyoList = this.dataset.klaviyoList;
      this.customSource = this.dataset.customSource || 'Mellenza homepage quiz popup';
      this.selectedAnswer = '';

      this.form = this.querySelector('[data-popup-form]');
      this.errorEl = this.querySelector('[data-popup-error]');
      this.submitBtn = this.querySelector('.quiz-popup__submit');
      this.submitLabel = this.querySelector('[data-submit-label]');
      this.originalLabel = this.submitLabel ? this.submitLabel.textContent : '';

      var self = this;
      this._onClose = function (e) {
        if (e.target.matches('[data-popup-close]')) self.close(true);
      };
      this._onKey = function (e) {
        if (e.key === 'Escape' && self.getAttribute('data-open') === 'true') self.close(true);
      };
      this._onSubmit = function (e) { e.preventDefault(); self.submit(); };

      this._onAnswerClick = function (e) {
        var btn = e.target.closest('[data-answer-value]');
        if (!btn) return;
        self.selectedAnswer = btn.getAttribute('data-answer-value') || '';
        self.setAttribute('data-view', 'form');
        var input = self.querySelector('input[type="email"]');
        if (input) window.setTimeout(function () { input.focus(); }, 120);
      };

      this.addEventListener('click', this._onClose);
      this.addEventListener('click', this._onAnswerClick);
      document.addEventListener('keydown', this._onKey);
      if (this.form) this.form.addEventListener('submit', this._onSubmit);

      if (this.designMode) {
        this.open();
        this._onSectionSelect = function (e) {
          if (e.detail && e.detail.sectionId && self.id.indexOf(e.detail.sectionId) !== -1) self.open();
        };
        document.addEventListener('shopify:section:select', this._onSectionSelect);
      } else {
        this.timer = window.setTimeout(function () { self.open(); }, this.delay * 1000);
      }
    };

    QuizPopup.prototype.disconnectedCallback = function () {
      window.clearTimeout(this.timer);
      document.removeEventListener('keydown', this._onKey);
      if (this._onSectionSelect) document.removeEventListener('shopify:section:select', this._onSectionSelect);
    };

    QuizPopup.prototype.open = function () {
      this.setAttribute('data-open', 'true');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    };

    QuizPopup.prototype.close = function (recordDismiss) {
      this.removeAttribute('data-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (this.designMode) return;
      if (recordDismiss && this.getAttribute('data-view') !== 'success') {
        writeCookie(DISMISS_COOKIE, '1', this.dismissDays);
      }
    };

    QuizPopup.prototype.submit = function () {
      var self = this;
      var input = this.form.querySelector('input[type="email"]');
      var email = (input.value || '').trim();
      if (!email || email.indexOf('@') === -1) {
        this.showError();
        return;
      }
      if (this.errorEl) this.errorEl.hidden = true;
      if (this.submitBtn) {
        this.submitBtn.setAttribute('aria-busy', 'true');
        if (this.submitLabel) this.submitLabel.textContent = '…';
      }

      if (this.designMode || !this.klaviyoKey || !this.klaviyoList) {
        this.setAttribute('data-view', 'success');
        if (this.submitBtn) {
          this.submitBtn.setAttribute('aria-busy', 'false');
          if (this.submitLabel) this.submitLabel.textContent = this.originalLabel;
        }
        return;
      }

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: this.customSource,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    hair_loss_cause: this.selectedAnswer || 'unspecified',
                    signup_source: 'homepage_quiz_popup'
                  }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: this.klaviyoList } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.klaviyoKey), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (res.status === 202) {
          writeCookie(SUBSCRIBE_COOKIE, '1', self.subscribeDays);
          self.setAttribute('data-view', 'success');
        } else {
          self.showError();
        }
      }).catch(function () {
        self.showError();
      }).then(function () {
        if (self.submitBtn) {
          self.submitBtn.setAttribute('aria-busy', 'false');
          if (self.submitLabel) self.submitLabel.textContent = self.originalLabel;
        }
      });
    };

    QuizPopup.prototype.showError = function () {
      if (this.errorEl) this.errorEl.hidden = false;
    };

    window.customElements.define('quiz-popup', QuizPopup);
  })();

  } catch(e) { console.error(e); }
})();
})();
